import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "card"];

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    this.cardTargets.forEach((card) => {
      const name = card.dataset.name?.toLowerCase() || "";
      const town = card.dataset.town?.toLowerCase() || "";
      const postcode = card.dataset.postcode?.toLowerCase() || "";

      const isMatch =
        name.includes(query) ||
        town.includes(query) ||
        postcode.includes(query);

      card.classList.toggle("hidden", !isMatch);
    });

    // This part handles the debounced analytics event.
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      // Only send the event if the query is meaningful (e.g., 3+ characters).
      if (query.length > 2) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'search',
          search_term: query
        });
      }
    }, 500); // 500 milliseconds (half a second)
  }
}
